// extracted by mini-css-extract-plugin
export default {"body":"m_2rd9","buttons":"olDWZL","button":"Veldgz","conversion":"VRsanl","socialButton":"vuBgV_"};